import React, { SyntheticEvent, useEffect, useState } from 'react';
import filtersStyles from '../../Filters.module.scss';
import { Action, CloseLight } from 'esa-ui-library';
import { useStore } from '../../../../../common';
import { PropertyType } from 'esa-ui-library/lib/types';
import { FilterDropdown } from '../FilterDropdown/FilterDropdown';
import { getActiveLabels, getFilterValue, getUpdateOptions, selectPreselectedOptions } from '../../Filters.helper';
import { cloneDeep, find } from 'lodash';
import useFilters from '../../../../../common/hooks/useFilters';

const PlayerCurrencyFilter = (): JSX.Element => {
	const [{ currencies, filters }] = useStore();
	const [filterOptions, setFiltersOptions] = useState<PropertyType[]>([]);
	const { onFilter } = useFilters();

	const onFilterChange = (option: PropertyType) => {
		const updateOptions = getUpdateOptions(option, filterOptions);
		const filterValue = getFilterValue(updateOptions, 'label');
		onFilter([{ name: 'currencies', value: filterValue }]);
	};

	const onFilterRemove = (e: SyntheticEvent) => {
		e.stopPropagation();

		onFilter([{ name: 'currencies', value: '' }]);
	};

	const getLabelContent = () => {
		const activeLabels = getActiveLabels(filterOptions);
		if (!activeLabels.length) return 'All';

		return (
			<>
				{activeLabels[0]}
				{activeLabels.length > 1 ? `+${activeLabels.length - 1}` : ''}
				<i className={filtersStyles.ClearFilter} onClick={onFilterRemove}>
					<CloseLight size={16} />
				</i>
			</>
		);
	};

	const onSelectAll = () => {
		if (!currencies || !currencies.length) return;
		const allLabels = currencies.map((c: PropertyType) => c.label).join(',');
		setFiltersOptions(selectPreselectedOptions(currencies, allLabels, 'label'));
		onFilter([{ name: 'currencies', value: allLabels }]);
	};

	useEffect(() => {
		if (currencies) {
			setFiltersOptions(cloneDeep(currencies));
		}
	}, [currencies]);

	useEffect(() => {
		const filter = find(filters, ['name', 'currencies'])?.value || '';
		setFiltersOptions(selectPreselectedOptions(currencies, filter, 'label'));
	}, [filters]);

	return (
		<Action
			label='Player Currency'
			labelContent={getLabelContent()}
			select
			className={`${filtersStyles.Filter} 
			${getActiveLabels(filterOptions).length ? filtersStyles.Active : ''} `}
			dataId='playercurrency-filter'
		>
			<FilterDropdown
				data={filterOptions}
				onChange={onFilterChange}
				isSearchable
				enableSelectAll
				onSelectAll={onSelectAll}
				selectAllLabel='Select All'
			/>
		</Action>
	);
};

export { PlayerCurrencyFilter };
